import type {
  DoctorShiftRepository,
  DeleteDoctorShiftParams,
  OperationResult,
} from './ports/DoctorShiftRepository';

/**
 * 医師シフト削除ユースケース
 *
 * @description
 * 既存の医師シフトを削除する。
 * 楽観的ロックにより同時編集の競合を検出する。
 *
 * @param {DoctorShiftRepository} repository - リポジトリ実装
 * @param {DeleteDoctorShiftParams} params - 削除パラメータ
 * @returns {Promise<OperationResult>} 操作結果
 *
 * @example
 * const result = await deleteDoctorShiftUseCase(repository, {
 *   id: 'shift-123',
 *   version: 1
 * });
 */
export const deleteDoctorShiftUseCase = async (
  repository: DoctorShiftRepository,
  params: DeleteDoctorShiftParams
): Promise<OperationResult> => {
  // IDは必須
  if (!params.id) {
    return {
      success: false,
      error: 'シフトIDが指定されていません。',
      errorCode: 'VALIDATION_ERROR',
    };
  }

  return repository.deleteShift(params);
};
